import MessageCenterTabs from './components/Tabs';
import SearchBar from './components/SearchBar';

import useMessageCenterCopy from 'modules/IMC/common/hooks/useMessageCenterCopy';
import DrawerHeader from 'modules/common/components/RightDrawer/DrawerHeader';
import { DrawerHeaderBaseProps } from 'modules/common/components/RightDrawer/DrawerHeader/DrawerHeader.interface';

function MessageCenterHeader({ startAction, containerRef, endActions, compressed, children }: DrawerHeaderBaseProps) {
    const { drawerTitle } = useMessageCenterCopy();

    return (
        <DrawerHeader
            title={drawerTitle}
            startAction={startAction}
            endActions={endActions}
            compressed={compressed}
            containerRef={containerRef}
            fixedContent={<MessageCenterTabs />}>
            <SearchBar placeholder="Search messages" />
            {children}
        </DrawerHeader>
    );
}

export default MessageCenterHeader;
